import { render, staticRenderFns } from "./MailInvoiceReporting.vue?vue&type=template&id=10b4ea1f&scoped=true&"
import script from "./MailInvoiceReporting.vue?vue&type=script&lang=js&"
export * from "./MailInvoiceReporting.vue?vue&type=script&lang=js&"
import style0 from "./MailInvoiceReporting.vue?vue&type=style&index=0&id=10b4ea1f&scoped=true&lang=css&"
import style1 from "./MailInvoiceReporting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4ea1f",
  null
  
)

export default component.exports